import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import { CONFIG } from 'src/config-global';

import { SplashScreen } from 'src/components/loading-screen';

import { authRoutes } from './auth';
import { errorRoutes } from './error';
import { displayRoutes } from './display';
import { managerRoutes } from './manager';
import { dashboardRoutes } from './dashboard';

const HomePage = lazy(() => import('src/pages/page'));
const NotFoundPage = lazy(() => import('src/pages/not-found'));

export function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      ),
      children: [
        { index: true, element: <HomePage /> },
        ...authRoutes,
        ...dashboardRoutes,
        ...managerRoutes,
        ...displayRoutes,
        ...errorRoutes,
        { path: '404', element: <NotFoundPage /> },
        { path: '*', element: <Navigate to="/error/404" replace /> },
      ],
    },
  ]);
}

// Re-exported for completeness (other parts of the app sometimes inspect CONFIG)
export { CONFIG };
